import React, { useState, useEffect } from 'react';
import { I18n } from 'react-redux-i18n';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { Button, DialogActions, DialogContent } from '@material-ui/core';
import Filters from '../components/Filters/Filters';

function ModalEditAccount({ account, floors, onClose, contacts, accountList }) {
	const [edits, setEdits] = useState({});
	const [linkedCustomerAccounts, setLinkedCustomerAccounts] = useState([]);

	useEffect(() => {
		if (accountList && account.type == 'customer') {
			const cusIds = accountList['customer'].reduce((acc, a) => {
				if (a._id != account._id && a.linking) {
					acc.push(...a.linking.map(l => l.id_table));
				}
				return acc;
			}, []);
			setLinkedCustomerAccounts(cusIds);
		}
	}, [accountList]);
	return (
		<Dialog
			id="modal-edit-account"
			onClose={() => onClose(null)}
			aria-labelledby="simple-dialog-title"
			open={true}>
			<h2 className="account-edit-title">
				Modification du compte{' '}
				{I18n.t('exportVat.account_type.' + account.type)} - N°
				{account.account_number}
			</h2>
			<DialogContent>
				{account.type == 'product' ? (
					<div>
						{' '}
						<label>
							Salles :{' '}
							<Filters
								multiple={true}
								monoSelect={false}
								label="Toutes les salles"
								selected={
									account.floors.length == 0
										? floors
										: account.floors.map(id => ({ id: id }))
								}
								datas={JSON.parse(JSON.stringify(floors))}
								paramsLabel="name"
								paramsValue="id"
								// inputClassName=""
								// inputLabelClassName=""
								onClose={(data, pValue) => {
									setEdits({
										...edits,
										floors:
											data.length === floors.length ? [] : data.map(o => o.id),
									});
									return;
								}}
							/>
						</label>
					</div>
				) : null}


				<p>
					{' '}
					<label>Libellé du compte : </label>
					<input
						value={edits.label || account.label}
						onChange={e => {
							setEdits({ ...edits, ['label']: e.target.value });
						}}
						className={`account-edit-input`}
					/>
				</p>
				<p>
					{' '}
					<label>N° du compte : </label>
					<input
						value={edits.account_number || account.account_number}
						onChange={e => {
							setEdits({ ...edits, ['account_number']: e.target.value });
						}}
						className={`account-edit-input`}
					/>
				</p>
				<p>
					{' '}
					<label>Libellé de l'écriture : </label>
					<input
						value={edits.analytics || account.analytics}
						onChange={e => {
							setEdits({ ...edits, ['analytics']: e.target.value });
						}}
						className={`account-edit-input`}
					/>
				</p>
				{['achats', 'ventes'].includes(account.type) ? (
					<p>
						{' '}
						<label>Identifiant mouvement : </label>
						<input
							value={edits.table_id || account.table_id}
							onChange={e => {
								setEdits({ ...edits, ['table_id']: e.target.value });
							}}
							className={`account-edit-input`}
						/>
					</p>
				) : null}

				{account.type == 'customer' ? (
					<p>
						{' '}
						<label>Compte Client : </label>
						<select
							value={edits.table_id || account.table_id}
							onChange={e => {
								setEdits({ ...edits, ['table_id']: e.target.value });
							}}>
							<option value="" disabled>
								Sélectionnez un compte
							</option>
							{contacts.map(c => {
								const disabled = linkedCustomerAccounts.includes(c.id);
								return (
									<option value={c.id} disabled={disabled}>
										{c.name} ({c.id})
									</option>
								);
							})}
						</select>
					</p>
				) : null}
			</DialogContent>

			<DialogActions>
				<Button color="primary" onClick={() => onClose(null)}>
					Annuler
				</Button>
				<Button
					variant="contained"
					color="primary"
					onClick={() => onClose({ ...account, ...edits })}>
					Enregistrer
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default ModalEditAccount;
